// ----------------------
// <auto-generated>
// Generated by PermissionsGenerator.
// </auto-generated>
// ----------------------

export class AdministrationPermissions {
    static _ = 'Administration';

    static User = class {
        static _ = 'Administration.User';

        static ViewAll = 'Administration.User.ViewAll';
        static ViewOwn = 'Administration.User.ViewOwn';
        static Edit = 'Administration.User.Edit';
        static Create = 'Administration.User.Create';
    };

    static Role = class {
        static _ = 'Administration.Role';

        static ViewAll = 'Administration.Role.ViewAll';
        static ViewOwn = 'Administration.Role.ViewOwn';
        static Edit = 'Administration.Role.Edit';
        static Create = 'Administration.Role.Create';
    };

    static Organization = class {
        static _ = 'Administration.Organization';

        static ViewAll = 'Administration.Organization.ViewAll';
        static ViewOwn = 'Administration.Organization.ViewOwn';
        static Edit = 'Administration.Organization.Edit';
        static Create = 'Administration.Organization.Create';
    };

    static Settings = class {
        static _ = 'Administration.Settings';

        static View = 'Administration.Settings.View';
        static Edit = 'Administration.Settings.Edit';
    };

}

export class CodeListPermissions {
    static _ = 'CodeList';

    static Edit = class {
        static _ = 'CodeList.Edit';

        static Pilots = 'CodeList.Edit.Pilots';
    };

}

export class ReportingPermissions {
    static _ = 'Reporting';

    static View = class {
        static _ = 'Reporting.View';

        static VesselSchedule = 'Reporting.View.VesselSchedule';
        static ShipPlan = 'Reporting.View.ShipPlan';
        static VesselsInOrder = 'Reporting.View.VesselsInOrder';
        static ShipsAndYachts = 'Reporting.View.ShipsAndYachts';
        static VesselOperations = 'Reporting.View.VesselOperations';
        static FerryTerminal = 'Reporting.View.FerryTerminal';
        static TerminalOperations = 'Reporting.View.TerminalOperations';
        static IndirectProcessingReport = 'Reporting.View.IndirectProcessingReport';
        static SilosReport = 'Reporting.View.SilosReport';
        static DailyReport = 'Reporting.View.DailyReport';
    };

}

export class ServiceRequestPermissions {
    static _ = 'ServiceRequest';

    static View = class {
        static _ = 'ServiceRequest.View';

        static All = 'ServiceRequest.View.All';
        static Own = 'ServiceRequest.View.Own';
        static FreightForwarder = 'ServiceRequest.View.FreightForwarder';
    };

    static Action = class {
        static _ = 'ServiceRequest.Action';

        static Edit = 'ServiceRequest.Action.Edit';
        static Create = 'ServiceRequest.Action.Create';
        static Plan = 'ServiceRequest.Action.Plan';
        static Cancel = 'ServiceRequest.Action.Cancel';
        static Decline = 'ServiceRequest.Action.Decline';
        static Approve = 'ServiceRequest.Action.Approve';
        static Complete = 'ServiceRequest.Action.Complete';
        static Clone = 'ServiceRequest.Action.Clone';
        static CreateWarehouseDocument = 'ServiceRequest.Action.CreateWarehouseDocument';
        static Confirm = 'ServiceRequest.Action.Confirm';
    };

}

export class StockRecordPermissions {
    static _ = 'StockRecord';

    static View = class {
        static _ = 'StockRecord.View';

        static All = 'StockRecord.View.All';
        static Own = 'StockRecord.View.Own';
        static FreightForwarder = 'StockRecord.View.FreightForwarder';
    };

    static Action = class {
        static _ = 'StockRecord.Action';

        static Edit = 'StockRecord.Action.Edit';
        static Create = 'StockRecord.Action.Create';
        static ExitServiceRequest = 'StockRecord.Action.ExitServiceRequest';
        static InsertRemark = 'StockRecord.Action.InsertRemark';
        static InspectionEntry = 'StockRecord.Action.InspectionEntry';
    };

}

export class VesselPermissions {
    static _ = 'Vessel';

    static View = class {
        static _ = 'Vessel.View';

        static All = 'Vessel.View.All';
        static Own = 'Vessel.View.Own';
    };

    static Action = class {
        static _ = 'Vessel.Action';

        static Edit = 'Vessel.Action.Edit';
        static Create = 'Vessel.Action.Create';
        static Approve = 'Vessel.Action.Approve';
    };

}

export class VesselVisitPermissions {
    static _ = 'VesselVisit';

    static View = class {
        static _ = 'VesselVisit.View';

        static All = 'VesselVisit.View.All';
        static Own = 'VesselVisit.View.Own';
        static FreightForwarder = 'VesselVisit.View.FreightForwarder';
    };

    static Action = class {
        static _ = 'VesselVisit.Action';

        static Edit = 'VesselVisit.Action.Edit';
        static Create = 'VesselVisit.Action.Create';
        static Cancel = 'VesselVisit.Action.Cancel';
        static Arrive = 'VesselVisit.Action.Arrive';
        static YachtArrive = 'VesselVisit.Action.YachtArrive';
        static Depart = 'VesselVisit.Action.Depart';
        static YachtDeparture = 'VesselVisit.Action.YachtDeparture';
        static Anchor = 'VesselVisit.Action.Anchor';
        static UpdateBerth = 'VesselVisit.Action.UpdateBerth';
        static Approve = 'VesselVisit.Action.Approve';
        static UpdatePosition = 'VesselVisit.Action.UpdatePosition';
    };

    static Add = class {
        static _ = 'VesselVisit.Add';

        static PilotTime = 'VesselVisit.Add.PilotTime';
        static CargoAgent = 'VesselVisit.Add.CargoAgent';
        static FreightForwarder = 'VesselVisit.Add.FreightForwarder';
        static Movement = 'VesselVisit.Add.Movement';
    };

    static Operations = class {
        static _ = 'VesselVisit.Operations';

        static OperationStart = 'VesselVisit.Operations.OperationStart';
        static OperationEnd = 'VesselVisit.Operations.OperationEnd';
        static OperationalData = 'VesselVisit.Operations.OperationalData';
        static OperationalProgress = 'VesselVisit.Operations.OperationalProgress';
    };

    static Standstills = class {
        static _ = 'VesselVisit.Standstills';

        static View = 'VesselVisit.Standstills.View';
        static Add = 'VesselVisit.Standstills.Add';
    };

    static Documents = class {
        static _ = 'VesselVisit.Documents';

        static ChangeStatus = 'VesselVisit.Documents.ChangeStatus';
    };

}

export class VesselVisitDocumentPermissions {
    static _ = 'VesselVisitDocument';

    static View = class {
        static _ = 'VesselVisitDocument.View';

        static All = 'VesselVisitDocument.View.All';
        static Own = 'VesselVisitDocument.View.Own';
    };

    static Action = class {
        static _ = 'VesselVisitDocument.Action';

        static Edit = 'VesselVisitDocument.Action.Edit';        
        static Create = 'VesselVisitDocument.Action.Create';        
        static Approve = "VesselVisitDocument.Action.Approve";
        static ApproveAgent = "VesselVisitDocument.Action.ApproveAgent";
        static ApproveDispatch = "VesselVisitDocument.Action.ApproveDispatch";
        static ApproveDispatchShift = "VesselVisitDocument.Action.ApproveDispatchShift";        
        static ReceiveFSPD = "VesselVisitDocument.Action.ReceiveFSPD";
        static ReceiveCaptain = "VesselVisitDocument.Action.ReceiveCaptain";
        static Reject = "VesselVisitDocument.Action.Reject";
    };
}

export class WarehouseDocumentPermissions {
    static _ = 'WarehouseDocument';

    static View = class {
        static _ = 'WarehouseDocument.View';

        static All = 'WarehouseDocument.View.All';
        static Own = 'WarehouseDocument.View.Own';
        static FreightForwarder = 'WarehouseDocument.View.FreightForwarder';
    };

    static Action = class {
        static _ = 'WarehouseDocument.Action';

        static Edit = 'WarehouseDocument.Action.Edit';
        static Create = 'WarehouseDocument.Action.Create';
        static Cancel = 'WarehouseDocument.Action.Cancel';
        static Complete = 'WarehouseDocument.Action.Complete';
    };

}


